import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavLogoImg,
  HamburgerIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavExternalLink,
  LanguageButton,
  LanguageContainer,
} from "./Navbar.elements";
import { FaTimes, FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";

const RECRUITING_URL = "https://recruiting.basakansoft.com";

function Navbar() {
  const [click, setClick] = useState(false);
  const [language, setLanguage] = useState("ko");
  const [scrolled, setScrolled] = useState(false);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/en")) {
      setLanguage("en");
    } else if (location.pathname.startsWith("/ko")) {
      setLanguage("ko");
    } else {
      const savedLang = localStorage.getItem("language") || "ko";
      setLanguage(savedLang);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const toggleLanguage = () => {
    const newLang = language === "ko" ? "en" : "ko";
    setLanguage(newLang);
    localStorage.setItem("language", newLang);
    // 보고 있던 페이지(예: /ko/newsletter/foo)를 유지한 채 언어만 바꾼다.
    const subPath = location.pathname.replace(/^\/(ko|en)/, "");
    history.push(`/${newLang}${subPath}`);
    window.dispatchEvent(new CustomEvent("languageChange", { detail: newLang }));
  };

  const menuItems = {
    ko: {
      home: "홈",
      newsletter: "뉴스레터",
      careers: "채용",
    },
    en: {
      home: "Home",
      newsletter: "Newsletter",
      careers: "Careers",
    },
  };

  return (
    <>
      <IconContext.Provider value={{ color: "#1f1a12" }}>
        <Nav scrolled={scrolled}>
          <NavbarContainer>
            <NavLogo to="/" onClick={closeMobileMenu}>
              <NavLogoImg
                src={language === "ko" ? "/logo_korean.png" : "/logo_english.png"}
                alt="바삭한소프트"
              />
            </NavLogo>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLinks to="/#home" onClick={closeMobileMenu}>
                  {menuItems[language].home}
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to={`/${language}/newsletter`} onClick={closeMobileMenu}>
                  {menuItems[language].newsletter}
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavExternalLink
                  href={RECRUITING_URL}
                  target="_blank"
                  rel="noreferrer"
                  onClick={closeMobileMenu}
                >
                  {menuItems[language].careers}
                </NavExternalLink>
              </NavItem>
              <LanguageContainer>
                <LanguageButton onClick={toggleLanguage}>
                  {language === "ko" ? "EN" : "KO"}
                </LanguageButton>
              </LanguageContainer>
            </NavMenu>
            <HamburgerIcon onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </HamburgerIcon>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
